import styled, { css } from 'styled-components'

export const PriceWrapper = styled.span`
    display: inline-flex;
    align-items: baseline;
    color: inherit;
`

export const Cents = styled.sup<{ $isExpose?: boolean }>`
    ${({ $isExpose }) => css`
        font-size: ${$isExpose ? '0.4em' : '0.6em'};
        line-height: 1;
        vertical-align: super;
        margin-left: 1px;
        top: ${$isExpose ? '-1.5em' : '-0.8em'};
        color: inherit;
    `}
`
